import { motion } from 'framer-motion';

const familyImage = 'https://customer-assets.emergentagent.com/job_connect-premium-2/artifacts/rv37orge_family%205.jpg';

const FinalCTA = ({ onReserveClick }) => {
  return (
    <section className="cta-section section relative overflow-hidden" data-testid="final-cta-section">
      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center lg:text-left"
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-[#1A1A1A] mb-4">
              Join the Founding Members.
            </h2>
            <p className="text-[#5A5A5A] text-base mb-8 max-w-md mx-auto lg:mx-0">
              Get priority access, launch updates, and early delivery windows.
            </p>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={onReserveClick}
              className="bg-[#1A1A1A] text-white px-8 py-4 rounded-full text-base font-medium
                         hover:bg-[#333] transition-all duration-300 btn-hover shadow-lg"
              data-testid="final-cta-reserve-btn"
            >
              Reserve Your Connect
            </motion.button>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="hidden lg:block"
          >
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src={familyImage}
                alt="Family walking together in nature"
                className="w-full h-[340px] object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
